import {evolve} from 'ramda';
import {over} from 'utils/lenses';
import {replace} from 'utils/objects';
import initState from './state';
import {parseNullableNumber, parseNullableString} from 'utils/fields';

export const formatQueryAreas = areas => {
	if (!areas) return [];
	if (typeof areas === 'string') {
		// for campaigns made with old app to work
		return areas.split(',').map(a => ({id: Number(a)}));
	}
	return areas;
};

export const parseUrlQuery = query => {
	const vals = evolve(
		{
			_page: Number,
			manufacturingYearEnd: parseNullableNumber,
			areas: str => formatQueryAreas(str ? JSON.parse(str) : []),
			campaign: parseNullableNumber,
			dismissPrompt: str => (str ? JSON.parse(str) : false),
			tagIds: parseNullableString,
		},
		query,
	);
	return {buildingsQuery: replace(vals, initState.buildingsQuery)};
};

export const formatUrlQuery = ({buildingsQuery}) => {
	return buildingsQuery.areas
		? over(['areas'], JSON.stringify, buildingsQuery)
		: buildingsQuery;
};

export const formatFetchableBuildingsQuery = ({buildingsQuery}) => {
	return buildingsQuery.areas
		? over(['areas'], areas => areas.map(a => a.id).join(','), buildingsQuery)
		: buildingsQuery;
};

export const formatBuildingsSearchInput = ({buildingsQuery}) => {
	return {
		manufacturingYearEnd: buildingsQuery.manufacturingYearEnd,
		areas: buildingsQuery.areas,
		tagIds: buildingsQuery.tagIds,
	};
};

export const formatCallCampaignsFormInitValues = ({buildingsQuery}) => {
	return {
		campaign: buildingsQuery.campaign,
	};
};

export const formatCallCampaignCreateOutput = ({title, buildingsQuery, userId}) => {
	return {
		title,
		query: JSON.stringify(buildingsQuery),
		userId,
		type: 'call',
	};
};

export const formatCallCampaignUpdateOutput = ({id, buildingsQuery}) => {
	return {
		id,
		query: JSON.stringify(buildingsQuery),
	};
};
